import mapStyleWhite from '../assets/mapStyle/mapStyleWhite.webp'
import mapStyleDark from '../assets/mapStyle/mapStyleDark.webp'
import mapStyleBasic from '../assets/mapStyle/mapStyleBasic.webp'
import mapStyleOSM from '../assets/mapStyle/mapStyleOSM.webp'
import mapStyleSatellite from '../assets/mapStyle/mapStyleSatellite.webp'
import mapStyleOutdoor from '../assets/mapStyle/mapStyleOutdoor.webp'
import mapStyleWinter from '../assets/mapStyle/mapStyleWinter.webp'
import mapStyleDataVizLight from '../assets/mapStyle/mapStyleDataVizLight.png'
import mapStyleDataVizDark from '../assets/mapStyle/mapStyleDataVizDark.png'
import mapStyleBright from '../assets/mapStyle/mapStyleBright.png'
import mapStyleOcean from '../assets/mapStyle/mapStyleOcean.png'
import mapStyleBackdrop from '../assets/mapStyle/mapStyleBackdrop.png'
import { CheckOutlined } from "@ant-design/icons";
import './SingleLayerSettingsLayer.css'

export function SingleLayerSettingsLayer({
    mapTheme,
    setMapTheme
}) {
    function changeMapTheme(theme) {
        setMapTheme(theme)
    }

    return (
        <div className="layerSettingsContainer">
            <div className="layerSettings">
                <p style={{
                    marginTop: 0
                }}>Select your favorite theme:</p>
                <div className="SingleLayerSettingsLayerBox">
                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleWhite})`,
                        }}
                        onClick={() => changeMapTheme('basic-v2-light/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'basic-v2-light/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleDark})`,
                        }}
                        onClick={() => changeMapTheme('basic-v2-dark/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'basic-v2-dark/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleBasic})`,
                        }}
                        onClick={() => changeMapTheme('basic-v2/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'basic-v2/{z}/{x}/{y}@2x.png' && <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleOSM})`,
                        }}
                        onClick={() => changeMapTheme('openstreetmap/{z}/{x}/{y}@2x.jpg')}>
                        {mapTheme === 'openstreetmap/{z}/{x}/{y}@2x.jpg' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleSatellite})`,
                        }}
                        onClick={() => changeMapTheme('satellite/{z}/{x}/{y}@2x.jpg')}>
                        {mapTheme === 'satellite/{z}/{x}/{y}@2x.jpg' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleOutdoor})`,
                        }}
                        onClick={() => changeMapTheme('outdoor-v2/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'outdoor-v2/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleWinter})`,
                        }}
                        onClick={() => changeMapTheme('winter-v2/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'winter-v2/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleBright})`,
                        }}
                        onClick={() => changeMapTheme('bright-v2/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'bright-v2/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleDataVizLight})`,
                        }}
                        onClick={() => changeMapTheme('dataviz/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'dataviz/{z}/{x}/{y}@2x.png' && <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleDataVizDark})`,
                        }}
                        onClick={() => changeMapTheme('dataviz-dark/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'dataviz-dark/{z}/{x}/{y}@2x.png' &&
                            <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleOcean})`,
                        }}
                        onClick={() => changeMapTheme('ocean/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'ocean/{z}/{x}/{y}@2x.png' && <div className="selected"><CheckOutlined /></div>}
                    </div>

                    <div
                        className="SingleLayerSettingsLayerBoxItem"
                        style={{
                            backgroundImage: `url(${mapStyleBackdrop})`,
                        }}
                        onClick={() => changeMapTheme('backdrop/{z}/{x}/{y}@2x.png')}>
                        {mapTheme === 'backdrop/{z}/{x}/{y}@2x.png' && <div className="selected"><CheckOutlined /></div>}
                    </div>
                </div>
            </div>
        </div>
    )
}